"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _fill = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/fill"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes/CustomPropTypes"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _react = _interopRequireWildcard(require("react"));

var _pagination = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/pagination.css") : void 0);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _pagination.default);
/** **Pagination** is commonly used for tables and tiles. It allows
users to see how many pages of content exist, to navigate and
highlights which page they are currently viewing. This control
does not handle how many tiles or rows to display in a table.
This control simply adds a nice user experience to handle how to
navigate through a collection. The handling of which items to
display needs to be handled in the function that is passed in
the \`onClick\` method. */

var Pagination = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Pagination, _Component);

  var _super = _createSuper(Pagination);

  function Pagination(props, context) {
    var _this;

    (0, _classCallCheck2.default)(this, Pagination);
    _this = _super.call(this, props, context);
    _this.numberOfPages = 0;

    _this.pageClicked = function (event) {
      event.preventDefault();

      _this.setState({
        selectedPage: +event.target.text
      }, function () {
        return _this.props.onClick(_this.state.selectedPage);
      });
    };

    _this.navigateBack = function () {
      if (_this.state.selectedPage === 1) {
        return;
      }

      _this.setState(function (prevState) {
        return {
          selectedPage: --prevState.selectedPage
        };
      }, function () {
        return _this.props.onClick(_this.state.selectedPage);
      });
    };

    _this.navigateForward = function () {
      if (_this.state.selectedPage === _this.numberOfPages) {
        return;
      }

      _this.setState(function (prevState) {
        return {
          selectedPage: ++prevState.selectedPage
        };
      }, function () {
        return _this.props.onClick(_this.state.selectedPage);
      });
    };

    _this.createPaginationLinks = function (numberOfPages) {
      var _context, _context2;

      var linksToBeAdded = numberOfPages;
      var pageNumberOffset = 1;
      var maxPageNumber = _this.state.selectedPage + Math.ceil(_this.props.visiblePageTotal / 2); //if numberOfPages is more than noOfPages

      if (numberOfPages > _this.props.visiblePageTotal) {
        linksToBeAdded = _this.props.visiblePageTotal; //highest page number possible
        //all but the last page, selected page is the center of selection

        if (maxPageNumber <= numberOfPages) {
          pageNumberOffset = _this.state.selectedPage - Math.floor(_this.props.visiblePageTotal / 2) + 1;
        } else {
          //last page,selected page is to the right of the center
          pageNumberOffset = numberOfPages - Math.floor(_this.props.visiblePageTotal) + 1;
        } //prevent negative values on first page


        if (pageNumberOffset <= 0) {
          pageNumberOffset = 1;
        }
      } // create an array with number of pages and fill it with links


      var aPages = [];
      aPages = (0, _map.default)(_context = (0, _fill.default)(_context2 = Array(linksToBeAdded)).call(_context2)).call(_context, function (link, index) {
        return _this.getPaginationLink(index, pageNumberOffset);
      });

      if (pageNumberOffset > 1) {
        var prefix = [];
        prefix.push(_this.getPaginationLink(0, 1));
        prefix.push(_this.getPaginationMoreIndicator());
        aPages.unshift(prefix);
      }

      if (pageNumberOffset + linksToBeAdded <= _this.numberOfPages) {
        var postfix = [];
        postfix.push(_this.getPaginationMoreIndicator());
        postfix.push(_this.getPaginationLink(0, _this.numberOfPages));
        aPages.push(postfix);
      }

      return aPages;
    };

    _this.getPaginationLink = function (index, pageNumberOffset) {
      var isSelected = _this.state.selectedPage === index + pageNumberOffset;
      var paginationLinkClasses = classnames("".concat(_this.props.cssNamespace, "-pagination__link"), {
        'is-selected': isSelected
      });
      return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({}, _this.props.linkProps, {
        className: paginationLinkClasses,
        href: "#",
        key: "link-".concat(index),
        onClick: _this.pageClicked
      }), index + pageNumberOffset);
    };

    _this.getPaginationMoreIndicator = function () {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: classnames("".concat(_this.props.cssNamespace, "-pagination__link--more"))
      });
    };

    _this.state = {
      selectedPage: _this.props.initialPage
    };
    return _this;
  } // number of pages to show


  (0, _createClass2.default)(Pagination, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          itemsTotal = _this$props.itemsTotal,
          itemsPerPage = _this$props.itemsPerPage,
          displayTotal = _this$props.displayTotal,
          totalText = _this$props.totalText,
          className = _this$props.className,
          cssNamespace = _this$props.cssNamespace,
          linkProps = _this$props.linkProps,
          localizedText = _this$props.localizedText,
          displayTotalProps = _this$props.displayTotalProps,
          prevProps = _this$props.prevProps,
          nextProps = _this$props.nextProps,
          onClick = _this$props.onClick,
          initialPage = _this$props.initialPage,
          visiblePageTotal = _this$props.visiblePageTotal,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["itemsTotal", "itemsPerPage", "displayTotal", "totalText", "className", "cssNamespace", "linkProps", "localizedText", "displayTotalProps", "prevProps", "nextProps", "onClick", "initialPage", "visiblePageTotal"]); // calculate number of pages based on item total and items per page
      // check to make sure itemsPerPage != 0

      this.numberOfPages = Math.ceil(itemsTotal / (itemsPerPage || 10));
      var paginationClasses = classnames("".concat(cssNamespace, "-pagination"), className);
      return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
        className: paginationClasses
      }), displayTotal ? /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({}, displayTotalProps, {
        className: classnames("".concat(cssNamespace, "-pagination__total"))
      }), itemsTotal, " ", totalText) : '', /*#__PURE__*/_react.default.createElement("nav", {
        className: classnames("".concat(cssNamespace, "-pagination__nav"))
      }, /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({}, prevProps, {
        "aria-disabled": this.state.selectedPage === 1,
        "aria-label": localizedText.previous,
        className: classnames("".concat(cssNamespace, "-pagination__link"), "".concat(cssNamespace, "-pagination__link--previous")),
        href: "#",
        onClick: this.navigateBack
      })), this.createPaginationLinks(this.numberOfPages), /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({}, nextProps, {
        "aria-disabled": this.state.selectedPage === this.numberOfPages,
        "aria-label": localizedText.next,
        className: classnames("".concat(cssNamespace, "-pagination__link"), "".concat(cssNamespace, "-pagination__link--next")),
        href: "#",
        onClick: this.navigateForward
      }))));
    }
  }]);
  return Pagination;
}(_react.Component);

Pagination.displayName = 'Pagination';
process.env.NODE_ENV !== "production" ? Pagination.propTypes = {
  /** Total number of items. itemsTotal / itemsPerPage calculates
   * how many navigation items should be shown in the control */
  itemsTotal: _propTypes.default.number.isRequired,

  /**
   * Callback function; triggered when user clicks on any navigation item link
   * i.e. page number or previous or next arrow indicators.
   *
   * @param {number} selectedPage - page number to navigate to.
   * @returns {void}
  */
  onClick: _propTypes.default.func.isRequired,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Set to **true** to show total number of items along with `totalText` string */
  displayTotal: _propTypes.default.bool,

  /** Additional props to be spread to the display total `<span>` elements */
  displayTotalProps: _propTypes.default.object,

  /** Initial page to be selected */
  initialPage: _propTypes.default.number,

  /** Number of items to display on page */
  itemsPerPage: _propTypes.default.number,

  /** Additional props to be spread to the page number `<a>` elements */
  linkProps: _propTypes.default.object,
  localizedText: _CustomPropTypes.default.i18n({
    /** Value for aria-label on the next <a> element */
    next: _propTypes.default.string,

    /** Value for aria-label on the previous <a> element */
    previous: _propTypes.default.string
  }),

  /** Additional props to be spread to the next arrow `<a>` element */
  nextProps: _propTypes.default.object,

  /** Additional props to be spread to the previous arrow `<a>` element */
  prevProps: _propTypes.default.object,

  /** Localized text to display next to the total number of items.  Used with `displayTotal` */
  totalText: _propTypes.default.string,

  /** Total number of visible pages. Three page links will be displayed as default,along with the first and last page links*/
  visiblePageTotal: _propTypes.default.number
} : void 0;
Pagination.defaultProps = {
  displayTotal: true,
  initialPage: 1,
  itemsPerPage: 10,
  localizedText: {
    next: 'Next',
    previous: 'Previous'
  },
  totalText: 'items',
  visiblePageTotal: 3
};

var _default = (0, _withStyles.default)(Pagination);

exports.default = _default;